import { render, staticRenderFns } from "./PopupPrintReceiptDocument.vue?vue&type=template&id=5247d796&"
import script from "./PopupPrintReceiptDocument.vue?vue&type=script&lang=js&"
export * from "./PopupPrintReceiptDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports